import React from 'react';
import appointments from '../../../../../../../../../../services/appointments/index';
import doctors from '../../../../../../../../../../services/doctors/index';
import LoadingComponent from '../../../../../../../../../../components/loading/index';
import AppointmentRow from './components/appointment/index';
import { withRouter } from 'react-router-dom';
import PaginationComponent from '../../../../../../components/pagination/index';

export default withRouter(class Appointments extends React.Component {
    state = {
        appointments: null,
        numberOfElements: -1,
        page: 0
    }

    elementsPerPage = 10

    componentWillMount() {
        appointments.count({patient: this.props.patient._id}, (err,count) => {
            appointments.find({patient: this.props.patient._id})
                .sort({date: -1})
                .limit(this.elementsPerPage).skip(0)
                .exec((err, appointments) => {
                    this.setState({appointments: appointments, numberOfElements: count})
                })
        })
    }

    changePage = (page) => {
        appointments.find({patient: this.props.patient._id})
            .skip(page*this.elementsPerPage)
            .sort({date: -1})
            .limit(this.elementsPerPage)
            .exec((err, appointments) => {
                this.setState({appointments: appointments, page: page})
            })
    }

    renderRow = (appointment, index) => {
        return (
            <AppointmentRow key={index}
                details={this.openAppointmentDetails}
                appointment={appointment}
            />
        );
    }

    openAppointmentDetails = (id) => {
        this.props.history.push(`/appointment-details/${id}`)
    }

    render() {
        if(!this.state.appointments)
            return <LoadingComponent />

        return (
            <React.Fragment>
                <table className="table is-fullwidth is-hoverable">
                    <thead>
                        <tr>
                            <th>Servicio</th>
                            <th>Empleado</th>
                            <th>Fecha</th>
                            <th>Hora</th>
                            <th>Agendó</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.appointments.map(this.renderRow)}
                    </tbody>
                </table>
                <PaginationComponent
                    elementsPerPage={this.elementsPerPage}
                    numberOfElements={this.state.numberOfElements}
                    changePage={this.changePage}
                    currentPage={this.state.page}
                />
            </React.Fragment>
        );
    }
})


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/registers/scenes/patient-details/scenes/patient-tabs/components/appointments/index.js